import { useEffect } from 'react';
import { useUiStore } from '@/stores/ui';
import { cn } from '@/lib/utils';

export function GlobalNotice() {
  const notice = useUiStore((state) => state.notice);
  const clearNotice = useUiStore((state) => state.clearNotice);

  useEffect(() => {
    if (!notice) return;
    const handle = setTimeout(() => clearNotice(notice.id), 3000);
    return () => clearTimeout(handle);
  }, [clearNotice, notice]);

  if (!notice) return null;

  return (
    <div
      role="status"
      className={cn(
        'fixed bottom-4 right-4 z-[90] rounded-md border bg-popover px-3 py-2 text-[13px] shadow-lg',
        notice.tone === 'destructive'
          ? 'border-destructive/40 text-destructive'
          : 'border-border text-foreground',
      )}
    >
      {notice.message}
    </div>
  );
}
